import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Forms from "../../services/forms";
import { FormsConfigProvider } from "../deployment/forms/Context";
import FormTemplateEditor from "../deployment/forms/templates/FormTemplateEditor";
import GuidedExperience from "./GuidedExperience";
import Utils from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import Amplitude from "../../services/amplitude";

const GuestView = () => {
    const { id: deploymentId, objectSubTypeId: formTemplateName, objectSubTypeVersion: formTemplateVersion } = useParams();
    const history = useHistory();
    const [translate] = useTranslation();
    const [formConfig, setFormConfig] = useState();
    const [formDataLists, setFormDataLists] = useState();
    const [guideMetadata, setGuideMetadata] = useState();

    const containerRef = useRef(null);

    if (!window.sessionStorage.getItem('firstLoadGuest')) {
        Amplitude.logAmplitute({
            eventType: "Loaded GuestView TryIt",
            guestSession: JSON.parse(window.sessionStorage.getItem('guestTemplate') || "{}").guestSessionId || ""
        });
        window.sessionStorage.setItem('firstLoadGuest', true);
    }

    const getFormConfig = useCallback(async () => {
        const configResponse = await Forms.getFormConfig({
            deploymentId
        });
        if (!configResponse.error) {
            setFormConfig(configResponse.data);
        }
    }, [deploymentId]);

    const getFormDataLists = useCallback(async () => {
        const dataListsResponse = await Forms.getDataLists({
            deploymentId
        });
        if (!dataListsResponse.error) {
            setFormDataLists(dataListsResponse.data);
        }
    }, [deploymentId]);

    const getGuideMetadata = useCallback(async () => {
        const response = await Forms.getGuideMetadata({ deploymentId });
        if (!response.error) {
            setGuideMetadata(response.data);
        }
    }, [deploymentId]);

    useEffect(() => {
        if (!formConfig) {
            getFormConfig();
        }
    }, [formConfig, getFormConfig]);

    useEffect(() => {
        if (!formDataLists) {
            getFormDataLists();
        }
    }, [formDataLists, getFormDataLists]);

    useEffect(() => {
        if (!guideMetadata) {
            getGuideMetadata();
        }
    }, [guideMetadata, getGuideMetadata]);

    useEffect(() => {
        if (!formTemplateName || !formTemplateVersion) {
            history.push(Utils.routeToGuestHomePage());
        }
    }, [formTemplateName, formTemplateVersion, history]);

    const renderHelpText = useMemo(() => {
        if (!guideMetadata) {
            return null;
        }
        return <div className="h-lg-100 d-lg-flex flex-lg-column overflow-y-lg-hidden py-3 pe-lg-3">
            <h6 className="mb-2">{translate("OTM_GUIDED_EXPERIENCE_HEADER")}</h6>
            <GuidedExperience
                metadata={guideMetadata}
            />

        </div>
    }, [guideMetadata, translate]);

    return <>
        <div className="row g-0 flex-lg-grow-1 overflow-y-lg-hidden">
            <DndProvider backend={HTML5Backend}>
                <FormsConfigProvider
                    modalContainerRef={containerRef}
                    formConfig={formConfig}
                    formDataLists={formDataLists}
                    guestMode={true}>
                    <div className="col-12 col-lg-4 h-lg-100 overflow-y-lg-hidden border-lg-end">
                        {renderHelpText}
                    </div>
                    <div className="col-12 col-lg-8 h-lg-100 overflow-y-lg-hidden modal-container" ref={containerRef}>
                        <div className="h-lg-100 d-lg-flex flex-lg-column overflow-y-lg-hidden py-3 ps-lg-3">
                            <FormTemplateEditor />
                        </div>
                    </div>

                </FormsConfigProvider>
            </DndProvider>
        </div>
    </>
}

export default GuestView;